module.exports = __webpack_public_path__ + "img/6.b7a4de31.svg";